var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99974 5.172L11.9497 0.222L13.3637 1.636L6.99974 8L0.635742 1.636L2.04974 0.222L6.99974 5.172Z",
    fill: "#686868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropDown);
export default __webpack_public_path__ + "static/media/icon_drop_down.cdf7859d24966fc46c3c5569836f2093.svg";
export { ForwardRef as ReactComponent };